import {
  NOT_CORRECT_EXAM_FORM_SHOW,
  NOT_CORRECT_EXAM_FORM_HIDE,
  NOT_CORRECT_EXAM_FORM_CHANGE,
  NOT_CORRECT_EXAM_FORM_SUBMIT,
} from '../constants';
import { sendStats, CLICK_NOT_CORRECT_EXAM } from '../../resources/metrics';

export const changeNotCorrectExamForm = (payload) => ({
  type: NOT_CORRECT_EXAM_FORM_CHANGE,
  payload,
});

export const submitNotCorrectExamForm = () => {
  sendStats(CLICK_NOT_CORRECT_EXAM());

  return { type: NOT_CORRECT_EXAM_FORM_SUBMIT };
};

export const setNotCorrectExam = (payload) => (dispatch) => {
  dispatch({ type: NOT_CORRECT_EXAM_FORM_SHOW, payload });
};

export const unsetNotCorrectExam = () => (dispatch) => {
  dispatch({ type: NOT_CORRECT_EXAM_FORM_HIDE });
};
